import React from 'react'
import { connect } from 'react-redux'
import {Field, formValueSelector, reduxForm} from 'redux-form'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faRedo} from "@fortawesome/free-solid-svg-icons";
import {FormUtils} from "../utils/FormUtils";
import ApplePayForm from './products/ApplePayForm';

const requiredOrderId = FormUtils.validators.required('Order ID');

let InlineForm = props => {
  const { handleSubmit, reset, submitting, onPrevious, useOptionalFieldsValue, useCreditCardValue, paymentDetailsValue } = props;

  return (
    <div>
      <h3>Widget as an inline component</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="merchantId">Merchant ID</label>
          <Field className="form-control" name="merchantId" component="input" type="text" disabled={true}/>
        </div>
        <Field className="form-control" name="orderId" label="Order ID" component={FormUtils.renderField} type="text" placeholder="<YOUR_ORDER_ID>" validate={requiredOrderId} />
        <div className="form-group">
          <label htmlFor="language">Language</label>
          <Field className="form-control" name="language" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="layout">Layout</label>
          <Field className="form-control" name="layout" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="products">
            Products (comma "," separated). Leave empty for all products <br />
            <small>Options: 'creditcard', 'paypal','ratepay-invoice', 'ratepay-directdebit', 'ratepay-installment', 'sofort', 'ideal', 'klarna', 'alipay', 'bancontact',
              'wechat-pay', 'postfinance-card', 'payu', 'paysafecard', 'applepay', 'twint', 'union-pay'</small>
          </label>
          <Field className="form-control" name="products" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="customStyleId">Custom style id</label>
          <Field className="form-control" name="customStyleId" component="input" type="text" />
        </div>

        <div>
          <div>
            <h4>Risk settings:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="deviceIdent" component="input" type="checkbox" /> <b>Device Ident</b>
                </label>
              </div>
            </div>
            <h4>PayPal:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="paypalRecurringBillingAgreement" type="checkbox" /> <b>Recurring Billing
                  Agreement</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="paypalCallbacks" type="checkbox"/> <b>Use callbacks</b>
                </label>
              </div>
            </div>

            <h4>EDCC:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="edccCallbacks" type="checkbox"/> <b>Edcc Callback</b>
                </label>
              </div>
            </div>

            <ApplePayForm />

            <h4>Redirect user:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="redirectUser" type="checkbox" /> <b>Redirect user</b>
                </label>
              </div>
            </div>
            <h4>Mobile View:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="mobileView" type="checkbox" /> <b>Mobile View</b>
                </label>
              </div>
            </div>
          </div>
          <div>
            <h4>Additional configs:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="hidePayButton" component="input" type="checkbox" /> <b>Hide Pay Button</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="hideTitleIcons" type="checkbox" /> <b>Hide Title Icons</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="skipFinalResultView" type="checkbox" /> <b>Skip final result view</b>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3>Payment Details:</h3>
          <hr/>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="paymentDetailsUsage.general" component="input" type="checkbox"/> <b>Use Payment Details</b>
              </label>
            </div>
          </div>
          {paymentDetailsValue && paymentDetailsValue.general && <div>
            <h4>WeChat Pay:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="paymentDetailsUsage.wechatPay.general" component="input" type="checkbox"/> <b>Use WeChat Pay</b>
                </label>
              </div>
            </div>
            {paymentDetailsValue && paymentDetailsValue.wechatPay && paymentDetailsValue.wechatPay.general && <div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.wechatPay.countryCode" component="input" type="checkbox"/> <b>Country code</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.wechatPay && paymentDetailsValue.wechatPay.countryCode && <div>
                <div className="form-group">
                  <label htmlFor="paymentDetails.wechatPay.countryCode">Country Code</label>
                  <Field className="form-control" name="paymentDetails.wechatPay.countryCode" component="input" type="text"/>
                </div>
              </div>}
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.wechatPay.preferredLanguage" component="input" type="checkbox"/> <b>Preferred Language</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.wechatPay && paymentDetailsValue.wechatPay.preferredLanguage && <div>
                <div className="form-group">
                  <label htmlFor="paymentDetails.wechatPay.preferredLanguage">Preferred Language</label>
                  <Field className="form-control" name="paymentDetails.wechatPay.preferredLanguage" component="input" type="text"/>
                </div>
              </div>}
            </div>}            
            <h4>Bancontact:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="paymentDetailsUsage.bancontact.general" component="input" type="checkbox"/> <b>Use Bancontact</b>
                </label>
              </div>
            </div>
            {paymentDetailsValue && paymentDetailsValue.bancontact && paymentDetailsValue.bancontact.general && <div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.bancontact.preferredLanguage" component="input" type="checkbox"/> <b>Preferred Language</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.bancontact && paymentDetailsValue.bancontact.preferredLanguage && <div>
                <div className="form-group">
                  <label htmlFor="paymentDetails.bancontact.preferredLanguage">Preferred Language</label>
                  <Field className="form-control" name="paymentDetails.bancontact.preferredLanguage" component="input" type="text"/>
                </div>
              </div>}
            </div>}
            <h4>Paysafecard:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="paymentDetailsUsage.paysafecard.general" component="input" type="checkbox"/> <b>Use Paysafecard</b>
                </label>
              </div>
            </div>
            {paymentDetailsValue && paymentDetailsValue.paysafecard && paymentDetailsValue.paysafecard.general && <div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.paysafecard.countryCode" component="input" type="checkbox"/> <b>Country code</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.paysafecard && paymentDetailsValue.paysafecard.countryCode && <div>
                <div className="form-group">
                  <label htmlFor="paymentDetails.paysafecard.countryCode">Country Code</label>
                  <Field className="form-control" name="paymentDetails.paysafecard.countryCode" component="input" type="text"/>
                </div>
              </div>}
            </div>}
          </div>}
          {paymentDetailsValue && paymentDetailsValue.general && <div>
            <h4>PostFinance Card:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field name="paymentDetailsUsage.postfinanceCard.general" component="input" type="checkbox"/> <b>Use Postfinance Card</b>
                </label>
              </div>
            </div>
            {paymentDetailsValue && paymentDetailsValue.postfinanceCard && paymentDetailsValue.postfinanceCard.general && <div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="paymentDetailsUsage.postfinanceCard.displayLanguage" component="input" type="checkbox"/> <b>Display language</b>
                  </label>
                </div>
              </div>
              {paymentDetailsValue && paymentDetailsValue.postfinanceCard && paymentDetailsValue.postfinanceCard.displayLanguage && <div>
                <div className="form-group">
                  <label htmlFor="paymentDetails.postfinanceCard.displayLanguage">Display language</label>
                  <Field className="form-control" name="paymentDetails.postfinanceCard.displayLanguage" component="input" type="text"/>
                </div>
              </div>}
              {paymentDetailsValue && paymentDetailsValue.postfinanceCard && paymentDetailsValue.postfinanceCard.displayMobileScreen &&
              <div className="checkbox">
                <label>
                  <Field name="paymentDetails.postfinanceCard.displayMobileScreen" component="input" type="checkbox"/> <b>Display Mobile Screen</b>
                </label>
              </div>}
              {paymentDetailsValue && paymentDetailsValue.general && <div>
                <h4>Credit Card:</h4>
                <div className="form-group">
                  <div className="checkbox">
                    <label>
                      <Field name="paymentDetailsUsage.creditCard.general" component="input" type="checkbox"/> <b>Use Credit Card</b>
                    </label>
                  </div>
                </div>
                {paymentDetailsValue && paymentDetailsValue.creditCard && paymentDetailsValue.creditCard.general && <div>
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <Field name="paymentDetailsUsage.creditCard.forceChallenge" component="input" type="checkbox"/> <b>Force challenge</b>
                      </label>
                    </div>
                  </div>
                </div>}
              </div>}
            </div>}
          </div>}
        </div>
        <div>
          <h3>Optional fields:</h3>
          <hr/>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field component="input" name="optionalFields" type="checkbox" /> <b>Use optional fields</b>
              </label>
            </div>
          </div>
          {useOptionalFieldsValue && <div className="form-group">
            <h4>Credit card:</h4>
            <div className="form-group">
                <div className="checkbox">
                    <label>
                        <Field component="input" name="useCreditCard" type="checkbox" /> <b>Use credit card</b>
                    </label>
                </div>
            </div>
            {useCreditCardValue && <div className="form-group">
              <div className="form-group">
                  <div className="checkbox">
                      <label>
                          <Field component="input" name="creditCard.cardHolder" type="checkbox" /> <b>Card holder</b>
                      </label>
                  </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field component="input" name="creditCard.cvcNeeded" type="checkbox"/> <b>Cvc needed</b>
                  </label>
                </div>
              </div>
              <div className="form-group">
                <div className="dropdown">
                    <div>
                        <label htmlFor="creditCard.cofContract.type">COF Contract Type</label>
                    </div>
                    <Field component="select" name="creditCard.cofContract.type">
                        <option value="">Select type</option>
                        <option value="ONECLICK">ONECLICK</option>
                        <option value="UNSCHEDULED">UNSCHEDULED</option>
                        <option value="SCHEDULED">SCHEDULED</option>
                    </Field>
                </div>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field component="input" name="creditCard.cofContractSelected" type="checkbox"/> <b>COF Optional</b>
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="creditCard.cofContract.recurringExpiry">COF Recurring Expiry</label>
                <Field className="form-control" name="creditCard.cofContract.recurringExpiry" component="input" type="text"/>
              </div>
              <div className="form-group">
                <label htmlFor="creditCard.cofContract.recurringFrequency">COF Recurring Frequency</label>
                <Field className="form-control" name="creditCard.cofContract.recurringFrequency" component="input" type="text"/>
              </div>
            </div>}
            <h4>Sepa:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="sepa.bic" type="checkbox" /> <b>BIC</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="sepa.bankName" type="checkbox" /> <b>Bank Name</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <div className="dropdown">
                <div>
                  <label htmlFor="sepa.directDebitType">Direct Debit Type</label> <br />
                  <small>Options: 'SINGLE', 'FIRST'</small>
                </div>
                <Field className="form-control" component="input" name="sepa.directDebitType" type="text"/>
              </div>
            </div>
            <h4>Ratepay Direct Debit:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="ratepayDirectDebit.bic" type="checkbox" /> <b>BIC</b>
                </label>
              </div>
            </div>
            <h4>Ratepay Installment:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="ratepayInstallment.bic" type="checkbox"  /> <b>BIC</b>
                </label>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="ratepayInstallment.calculationTypes">
                Calculation Types (comma "," separated) <br/>
                <small>Options: 'calculation-rate', 'calculation-time'</small>
              </label>
              <Field className="form-control" name="ratepayInstallment.calculationTypes" component="input" type="text"/>
            </div>
            <div className="form-group">
              <label htmlFor="ratepayInstallment.paymentTypes">
                Payment Types (comma "," separated) <br/>
                <small>Options: 'direct-debit', 'bank-transfer'</small>
              </label>
              <Field className="form-control" name="ratepayInstallment.paymentTypes" component="input" type="text"/>
            </div>
            <h4>iDeal:</h4>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <Field component="input" name="ideal.bankName" type="checkbox" /> <b>Bank Name</b>
                </label>
              </div>
            </div>
          </div>}
        </div>

        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={onPrevious}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 text-center m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" disabled={submitting} onClick={reset}>
                <FontAwesomeIcon icon={faRedo} />
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="submit" className="btn btn-primary col-xs-12">
                <span className="btn-text">Init Inline Widget</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

InlineForm = reduxForm({
  form: 'inline'
})(InlineForm);

const selector = formValueSelector('inline');

InlineForm = connect(
  state => {
    const initialValues = {
      merchantId: state.config.environment.merchantId,
      orderId: state.order.order.orderId,
      language: 'en',
      products: null,
      layout: 'dropdown',
      customStyleId: null,
      hidePayButton: null,
      hideTitleIcons: null,
      skipFinalResultView: null,
      deviceIdent: null,
      paypalRecurringBillingAgreement: null,
      paypalCallbacks: true,
      edccCallbacks: true,
      redirectUser: null,
      mobileView: null,
      optionalFields: true,
      paymentDetailsUsage: {
        general: true,
        wechatPay: {
          general: true,
          countryCode: true,
          preferredLanguage: true
        },
        bancontact: {
          general: true,
          preferredLanguage: true
        },
        postfinanceCard: {
          general: true,
          displayLanguage: true,
          displayMobileScreen: true
        },
        paysafecard: {
          general: true,
          countryCode: true
        },
        creditCard: {
          general: true,
          forceChallenge: true
        }
      },
      paymentDetails: {
        wechatPay: {
          countryCode: 'CN',
          preferredLanguage: 'zh'
        },
        bancontact: {
          preferredLanguage: 'en'
        },
        postfinanceCard: {
          displayLanguage: 'en',
          displayMobileScreen: false
        },
        paysafecard: {
          countryCode: 'DE',
        },
        creditCard: {
          forceChallenge: true
        }
      },
      useCreditCard: true,
      creditCard: {
        cardHolder: true,
        cvcNeeded: true,
        cofContractSelected: false,
        cofContract: {
          type: null,
          recurringExpiry: '2020-08-01',
          recurringFrequency: 30
        }
      },
      sepa: {
        bankName: true,
        bic: true,
        directDebitType: 'SINGLE'
      },
      ratepayDirectDebit: {
        bic: true
      },
      ratepayInstallment: {
        bic: true,
        calculationTypes: 'calculation-rate,calculation-time',
        paymentTypes: 'direct-debit,bank-transfer'
      },
      ideal: {
        bankName: true
      },
      applepay: {
        merchantIdentifier: 'merchant.com.concardis.payengine.applepay.test',
        domainName: '66493564.ngrok.io',
        validateMerchantUrl: 'https://payengine.qaiware.org/session-server',
        displayName: 'Test merchant for Apple Pay',
        countryCode: 'DE',
        applepayCallbacks: true,
        useBillingAndShipping: false
      }
    };

    return {
      initialValues,
      useOptionalFieldsValue: selector(state, 'optionalFields'),
      useCreditCardValue: selector(state, 'useCreditCard'),
      paymentDetailsValue: selector(state, 'paymentDetailsUsage')
    };
  }
)(InlineForm);

export default InlineForm



// WEBPACK FOOTER //
// ./src/inline/InlineForm.js